import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RegCosting } from 'shared/models/regcosting';


@Injectable({
  providedIn: 'root'
})
export class RegTableService {

  constructor(private http: HttpClient) { }

  getRegCostingDetails() {
    return this.http.get<any>('assets/mockdata/REG_COSTING.json').toPromise()
    .then(res => <RegCosting[]>res.Reg_Cost)
  }
}
